import React from 'react';
import "./index.css";
import { VictoryChart, VictoryBar, VictoryLabel, VictoryAxis } from 'victory';
import Paper from 'material-ui/Paper';

const intToString = number => {
    let newString = number.toString();
    if (newString.length > 3) {
        return number.toFixed(2);
    } else if (newString.length === 3) {
        return number.toFixed(1);
    }
    return newString;
};

const Response = props => {
    
    if (props.questionAnswer.answerType === "Range") {
        let classAverage;
        let classStdDev;

        const validClassAnswers = props.questionAnswer.classAnswers.filter(numberStr => !isNaN(parseInt(numberStr, 10)));

        // Get Class Average and Std Dev
        classAverage = validClassAnswers
            .reduce((a, b) => parseInt(a, 10) + parseInt(b, 10), 0) / validClassAnswers.length
        classStdDev = validClassAnswers
            .map((elem) => Math.pow(parseInt(elem, 10) - classAverage, 2))
            .reduce((a, b) => a + b, 0) / validClassAnswers.length

        classAverage = intToString(classAverage)
        classStdDev = intToString(classStdDev);

        return (
            <div className="studentResponse">
                <h2>{props.index + 1}. {props.questionAnswer.question}</h2>
                <h3>Class scores</h3>
                <Paper zDepth={2} className="graph" style={{borderRadius: "8px"}}>
                    <VictoryChart
                        domainPadding={{x: 28}}
                    >
                        <VictoryAxis
                            label="Score"
                            style={{
                                axisLabel: {
                                  fontSize: 12,
                                  fontFamily: "sans-serif",
                                  padding: 20,
                                },
                                tickLabels: {
                                  fontSize: 11,
                                  fontFamily: "sans-serif"
                                }
                            }}
                            domain={{x: [1, 7]}}
                            tickValues={[1, 2, 3, 4, 5, 6, 7]}
                            tickFormat={(t) => `${Math.round(t)}`}
                            tickLabelComponent={<VictoryLabel dy={-7}/>}
                        />
                        <VictoryAxis dependentAxis
                            label="Number of Students"
                            style={{
                                axisLabel: {
                                    fontSize: 12,
                                    angle: -90,
                                    padding: 30,
                                    fontFamily: "sans-serif"
                                },
                                tickLabels: {
                                    fontSize: 11,
                                    fontFamily: "sans-serif"
                                }
                            }}
                            tickFormat={(t) => `${Math.round(t)}`}
                            tickLabelComponent={<VictoryLabel dx={5}/>}
                        />
                        <VictoryBar
                            style={{
                              data: {
                                fill: "#ef6a6e",
                                stroke: "#ef6a6e"
                              }
                            }}
                            barRatio={1.1}
                            padding={{left: 100, top: 100}}
                            data={[
                                { x: 1, y: props.questionAnswer.yValues[1]},
                                { x: 2, y: props.questionAnswer.yValues[2]},
                                { x: 3, y: props.questionAnswer.yValues[3]},
                                { x: 4, y: props.questionAnswer.yValues[4]},
                                { x: 5, y: props.questionAnswer.yValues[5]},
                                { x: 6, y: props.questionAnswer.yValues[6]},
                                { x: 7, y: props.questionAnswer.yValues[7]}
                            ]}
                        />
                    </VictoryChart>
                </Paper>
                <Paper zDepth={2} style={{borderRadius: "8px"}}>
                    <table style={{textAlign: "center", margin: "auto"}}>
                        <tbody>
                            <tr>
                                <th>Class Mean</th>
                                <th>Class Standard Deviation</th>
                            </tr>
                            <tr>
                                <td>{classAverage}</td>
                                <td>{classStdDev}</td>
                            </tr>
                        </tbody>
                    </table>
                </Paper>
            </div>
        )
    } else {
        return (
            <div className="studentResponse">
                <h2>{props.index + 1}. {props.questionAnswer.question}</h2>
                <Paper zDepth={2} style={{borderRadius: "8px"}}>
                    <table style={{textAlign: "center", margin: "auto"}}>
                        <tbody>
                            <tr>
                                <th style={{width: "50%"}}>Yes</th>
                                <th style={{width: "50%"}}>No</th>
                            </tr>
                            <tr>
                                <td style={{width: "50%"}}>{props.questionAnswer.yesNo["studentYes"]}</td>
                                <td style={{width: "50%"}}>{props.questionAnswer.yesNo["studentNo"]}</td>
                            </tr>
                        </tbody>
                    </table>
                </Paper>
           </div>
        )
    }
}

export default Response;
